import Input from 'semantic-ui-react/dist/es/elements/Input';
import './Input.css';

export default Input;
